import { css, cx } from '@emotion/css'
import { useTheme } from '@fable/theme'

interface Props {
  className?: string
  percentage: number
  width?: number | string
  strokeWidth?: number
  cutout?: boolean
  color?: string
  backgroundColor?: string
  transitionDelay?: number
  animate?: boolean
}

export const ProgressCircle = ({
  className = '',
  percentage,
  width = 128,
  strokeWidth = 14,
  cutout = false,
  color,
  backgroundColor,
  transitionDelay = 0,
  animate = true,
}: Props) => {
  const { colors } = useTheme()
  const radius = 70
  const cutoutValue = cutout ? 20 : 0
  const circumference = Math.round(2 * Math.PI * radius)
  const progress = ((100 - percentage) / 100) * circumference
  const progressValue = Math.round(progress)
  const totalProgress = (cutoutValue / 100) * circumference
  const mainColor = color || colors.uiWhite
  const bgColor = backgroundColor || colors.uiWhite50

  return (
    <svg
      data-testid="progress-circle"
      width={width}
      height={width}
      viewBox="0 0 200 200"
      className={cx(
        css`
          transform: rotate(${!!cutout ? 126 : 90}deg);
        `,
        className
      )}
    >
      <circle
        r={radius}
        cx="100"
        cy="100"
        fill="transparent"
        stroke={bgColor}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={totalProgress}
      />
      <circle
        data-testid="progress-circle-bar"
        className={cx(
          animate
            ? css`
                transition: stroke-dashoffset 1s ease-out;
                transition-delay: ${transitionDelay}s;
              `
            : ''
        )}
        r="70"
        cx="100"
        cy="100"
        fill="transparent"
        stroke={mainColor}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={isNaN(progressValue) ? 0 : progressValue}
      />
    </svg>
  )
}
